

import React, { useEffect, useState } from 'react';
import { Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import axios from 'axios';
import LinearProgress from '@mui/material/LinearProgress';
import { uploadFeedbackAttachmentSpoc, uploadFeedbackAttachmentCustomer, apiHostUrl } from '../../../constants/constants';
import useAxiosFetchData from '../../hooks/useAxiosFetchData';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const FileUpload = (props) => {
  const { t } = useTranslation();
  const [selectedFile, setSelectedFile] = useState([]);
  const [uploadedFile, setUploadedFile] = useState([]);
  const { csrfHeaderName, csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
  const roles = useSelector(state => state.role);
  const { roleId, setRoleId } = useState("");
  const [file, setFile] = useState({
    "fileName": "",
    "selectedFile": ""
  });
  const [progress, setProgress] = useState(0);
  const handleFileChange = (event) => {
    const tempFile = event.target.files[0];
    setSelectedFile(tempFile);
    console.log(event.target.files);
  };

  const [headers, setHeaders] = useState({
    'Content-Type': 'multipart/form-data',
    'X-CSRF-TOKEN': csrfToken,
  });

  const formData = new FormData();
  formData.append('uploadFile', selectedFile);
  formData.append('_csrf', csrfToken);

  console.log(roleId);
  // if (roles.userCurrRole.id === 104) {
  //   formData.append('serviceId', props.departmentId);
  //   formData.append('customerId', payload.bidderId);
  //   formData.append('hiddenBidderId', '');
  //   formData.append('yesNo', '-1');
  //   formData.append('bidderOrgName', '');
  //   formData.append('emailId', '');
  //   formData.append('phone', '');
  //   formData.append('mobileNo', '');
  //   formData.append('panNo', '');
  //   formData.append('vendorCode', '');
  //   formData.append('usetDataTable_length', '2');
  //   formData.append('bidderId', payload.bidderId);
  //   formData.append('_csrf', csrfToken);
  // }
//   if (roles.userCurrRole.id === 108) {
//     formData.append('hiddenBidderId', props.userId);
//     formData.append('_csrf', csrfToken);
//   }

//   const headers = {
//     'Content-Type': 'multipart/form-data',
//     'X-CSRF-TOKEN': csrfToken,

//   };

//   const handleUpload = () => {
//     // Handle the file upload logic
//     if (selectedFile.length === 0 ||!selectedFile) {
//       alert('Please select a file!');
//       return;
//     }
//     else{
//     if (roles.userCurrRole.id === 104) {
//       axios.post(uploadFeedbackAttachmentSpoc, formData, {
//         withCredentials: true,
//         headers,
//         onUploadProgress: (progressEvent) => {
//           const uploadPercentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);
//           setProgress(uploadPercentage);
//         },
//       })
//         .then((data) => {
//           console.log("hi");


//           setUploadedFile(data.data);

//         })
//         .catch((error) => {
//           console.log(error);
//         });


//       if (selectedFile) {
//         console.log('Uploading file:', selectedFile);
//         // Add your file upload logic here

//       } else {
//         console.error('No file selected.');
//       }
//     }
//     if (roles.userCurrRole.id === 108) {
//       axios.post(uploadFeedbackAttachmentCustomer, formData, {
//         withCredentials: true,
//         headers
//       })
//         .then((data) => {
//           console.log("hi");


//           setUploadedFile(data.data);

//         })
//         .catch((error) => {
//           console.log(error);
//         });


//       if (selectedFile) {
//         console.log('Uploading file:', selectedFile);
//         // Add your file upload logic here

//       } else {
//         console.error('No file selected.');
//       }
//     }
//   }
// };
const { fetchData: fetchUploadData } = useAxiosFetchData({
  url: props.fetchUrl,
  method: 'post',
  body: formData,
  headers: headers,
  onLoad: false
});
const handleUpload = () => {
  fetchUploadData().then((data) => {
      console.log(data);
      setUploadedFile(data);
  })
}
useEffect(() => {
  props.onChange(uploadedFile);
}, [selectedFile, file, uploadedFile])

return (
  <>
  {/* <div style={{
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid #8e8e8e',
    width: '-webkit-fill-available',
    borderRadius: '8px',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  }}>
    <input
      type="file"
      accept={props.fileTypes}
      onChange={handleFileChange}
      style={{ display: 'none' }}
      id="file-input"

    />
    <label htmlFor="file-input">
      <Button component="span" variant="outlined">
        Choose File
      </Button>
    </label>
    <Typography variant="body1" gutterBottom>
      {selectedFile.length != 0  ? `Selected File: ${selectedFile.name}` : 'No file selected'}
    </Typography>
    <Button variant="contained" color="success" onClick={handleUpload} disabled={!selectedFile}>
      Upload
    </Button>
    
  </div> */}

<Form.Control type="file" className={props?.className} onChange={props?.onChange} />
  {progress > 0  && (
    <LinearProgress variant="determinate" value={progress} />
  )}
  {progress === 100 && (
    <Typography color="textSecondary" variant="body2">
      {t('general.label.upload.complete')}
    </Typography>
  )}
 </>
);
};

export default FileUpload;